module.exports = __webpack_public_path__ + "static/media/pload.a9702d18.png";